import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Tilauksesi (kustannus kuukaudessa)',
    main: 'Tilauksesi',
    billing_settings: 'Laskutusasetukset',
  },
  form: {
    billing_mode: {
      label: 'Laskutustila',
    },
    has_trial: {
      label: 'Lisää ilmaisia kokeilupäiviä',
    },
    trial_days: {
      label: 'Kuinka monta kokeilupäivää tulisi olla?',
      placeholder: '21',
      validation: {
        required: 'Kokeilupäivät vaaditaan',
        min: '{{value}} on kokeilupäivien vähimmäisarvo',
        max: '{{value}} on kokeilupäivien enimmäisarvo',
      },
    },
  },
  fields: {
    created_at: 'Luotu <strong>{{date}}</strong>, tekijä <strong>{{manager}}</strong>',
    updated_at: 'Viimeksi päivitetty <strong>{{date}}</strong>, tekijä <strong>{{manager}}</strong>',
    trial_ends_at: 'Kokeilujaksolla <strong>{{date}}</strong> asti',
    trial_days: '{{trialDays}} päivän kokeilujakso alkaa julkaisupäivänä, sinulta veloitetaan kokeilujakson päätyttyä',
    resumable_until: 'Palautettavissa <strong>{{date}}</strong> asti',
    ended_at: 'Päättyi <strong>{{date}}</strong>',
    next_bill_at: 'Seuraava lasku <strong>{{date}}</strong>',
    product: 'Tuote',
    quantity: 'Määrä',
    price: 'Nettohinta',
    tax: 'Vero',
    amount: 'Summa',
    net: 'Netto',
    tax_percentage: 'Vero {{rate}}%',
    total: 'Yhteensä veloitettava kuukaudessa',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Veloitus maksutavasta',
    [BillingMode.InternalInvoicing]: 'Veloitus myynnistä',
  },
  labels: {
    included: 'sisältyy',
    sales_based_discount:
      'Korissa on tuote, jonka hinta vaihtelee, todellinen hinta lasketaan tilauksen luonnin/päivityksen yhteydessä viime kuukauden myyntitietojen perusteella',
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    resume: 'Jatka',
  },
  modals: {
    cancel_subscription: {
      title: 'Peruutetaanko {{company}}:n tilaus?',
      description:
        'Tämä peruuttaa valitun tilauksen, mukaan lukien <strong>{{products}}</strong> (<strong>yhteensä {{total}}</strong>). Tilaus voidaan vielä palauttaa <strong>{{billingAnchor}}</strong> asti, jos asiakas muuttaa mielensä. Jos tilausta ei palauteta siihen mennessä, on luotava uusi tilaus',
    },
    resume_subscription: {
      title: 'Jatketaanko {{company}}:n tilausta?',
      description:
        'Tämä jatkaa valittua tilausta, mukaan lukien <strong>{{products}}</strong>. Ravintolalta veloitetaan <strong>{{total}}</strong> joka kuukausi alkaen <strong>{{billingAnchor}}</strong>',
    },
  },
  toasts: {
    cancel_subscription:
      'Jos haluat peruuttaa tilauksesi, ota yhteyttä soittamalla tai sähköpostitse {{provider}}-yhteyshenkilöösi. Yhteyshenkilösi peruuttaa tilauksen puolestasi välittömästi.',
    failed_to_cancel_subscription: 'Jokin meni pieleen tilauksen peruuttamisessa. Ota yhteyttä tekniseen tukeen',
    resume_subscription:
      'Jos haluat jatkaa tilaustasi, ota yhteyttä soittamalla tai sähköpostitse {{provider}}-yhteyshenkilöösi. Yhteyshenkilösi jatkaa tilausta puolestasi välittömästi.',
    failed_to_resume_subscription: 'Jokin meni pieleen tilauksen jatkamisessa. Ota yhteyttä tekniseen tukeen',
  },
};
